import type { NavigateFunction } from 'react-router';
import { useNavigate, useParams } from 'react-router';

import { bookingsRoutes } from '@zen/Routes';

import { getBookingScopeFromSlug, getBookingScopeSlug } from '../../helpers';
import type { BookingScope, UseBookingListScopeResult } from '../types';

const useBookingListScope = (): UseBookingListScopeResult => {
  const navigate: NavigateFunction = useNavigate();
  const { scope: scopeSlug } = useParams<{ scope?: string }>();
  const activeScope: BookingScope = getBookingScopeFromSlug(scopeSlug);

  const setActiveScope = (scope: BookingScope): void => {
    navigate(bookingsRoutes.index.getUrl(getBookingScopeSlug(scope)));
  };

  return { activeScope, setActiveScope };
};

export default useBookingListScope;
